import { Check } from '@phosphor-icons/react';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

// HORO-10509: matches the Figma "active input field" state exactly — a
// live checklist under the password field, each rule ticking a checkmark
// as it's satisfied while the user types. Same 4 rules PASSWORD_REGEX
// enforces server- and client-side, kept as individual booleans here
// (rather than one regex test) so each line can light up independently.
const RULES = [
    { key: 'atLeast8Chars', test: (password) => password.length >= 8 },
    { key: 'atLeastOneNumber', test: (password) => /\d/.test(password) },
    { key: 'atLeastOneUppercase', test: (password) => /[A-Z]/.test(password) },
    { key: 'atLeastOneUniqueChar', test: (password) => /[^A-Za-z0-9]/.test(password) }
];

const PasswordRequirementsChecklist = ({ password = '' }) => {
    const { t } = useTranslation();
    const results = useMemo(() => RULES.map((rule) => ({ ...rule, met: rule.test(password) })), [password]);

    return (
        <ul className={styles.checklist}>
            {results.map(({ key, met }) => (
                <li key={key} className={classNames(styles.checklistItem, { [styles.checklistItemMet]: met })}>
                    {t(`modal.passwordRule.${key}`)}
                    {/* HORO-10509: Figma's own checkmark (Dev Mode: a thin
                        white-stroked vector, no fill) — not the green ✓
                        this used to render. Same Check icon EntryStep's
                        benefit list already uses, for one consistent
                        checkmark across the auth flows rather than two. */}
                    {met && (
                        <span className={styles.checklistCheck}>
                            <Check size={12} color="#FFFFFF" weight="bold" />
                        </span>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default PasswordRequirementsChecklist;
